'use client';

import { SDKResponse } from '@commercetools/frontend-sdk';
import { PageResponse } from '@commercetools/frontend-sdk/lib/types/api/page';
import { useCookies } from 'next-client-cookies';
import { ProjectSettings } from 'shared/types/ProjectSettings';
import Toaster from 'components/commercetools-ui/atoms/toaster';
import AddToCartOverlayProvider from 'context/add-to-cart-overlay';
import { sdk } from 'sdk';
import { CategoryBarProvider } from './categoryBar';
import { StoreFinderProvider } from './store-finder';
import { SWRProvider } from './swr';
import TracingProvider from './tracing';
import { GetAccountActionReturn } from '../sdk/composable-commerce/types/actions/AccountActions';

interface ProvidersProps {
  accountResult?: SDKResponse<GetAccountActionReturn>;
  page: SDKResponse<PageResponse>;
  projectSettings?: SDKResponse<ProjectSettings>;
}

export const Providers = ({
  accountResult,
  projectSettings,
  page,
  children,
}: React.PropsWithChildren<ProvidersProps>) => {
  const cookies = useCookies();
  const locale = cookies.get('locale') as string;

  sdk.defaultConfigure(locale);

  return (
    <TracingProvider page={page}>
      <SWRProvider
        value={{
          fallback: {
            '/action/account/getAccount': accountResult,
            '/action/project/getProjectSettings': projectSettings,
          },
        }}
      >
        <StoreFinderProvider>
          <CategoryBarProvider>
            <AddToCartOverlayProvider>{children}</AddToCartOverlayProvider>
          </CategoryBarProvider>
        </StoreFinderProvider>

        <Toaster />
      </SWRProvider>
    </TracingProvider>
  );
};
